import React from 'react';
import PropTypes from 'prop-types';

import Segmented from './Segmented';

export const EMPTY_BONUS = { operator: 'CASH', ticketThreshold: '', amount: '' };

// Tiered artist bonuses, edited the same way as Deposits: rows held in the deal
// form's local state and synced to V3BudgetBonusesController on save. The single
// amount field is a dollar payout under CASH or a percentage of ticket sales
// under PERCENTAGE — matching the V3 bonus model.
const BonusRows = ({ bonuses, onChange }) => {
  const update = (index, patch) => {
    onChange(bonuses.map((b, i) => (i === index ? { ...b, ...patch } : b)));
  };
  const remove = (index) => onChange(bonuses.filter((_, i) => i !== index));
  const add = () => onChange([...bonuses, EMPTY_BONUS]);

  return (
    <section className="simple-offer__section">
      <h3 className="simple-offer__section-title">BONUS</h3>

      {bonuses.map((b, i) => {
        const isCash = b.operator !== 'PERCENTAGE';
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className="simple-offer__deposit-row" data-testid="bonus-row" key={i}>
            <label className="simple-offer__field">
              <span className="simple-offer__label">Ticket threshold</span>
              <input
                data-testid="bonus-threshold"
                className="simple-offer__input"
                type="number"
                value={b.ticketThreshold}
                onChange={(e) => update(i, { ticketThreshold: e.target.value })}
              />
            </label>

            <div className="simple-offer__field">
              <span className="simple-offer__label">Bonus type</span>
              <Segmented
                ariaLabel="Bonus type"
                value={isCash ? 'CASH' : 'PERCENTAGE'}
                options={[{ value: 'CASH', label: '$' }, { value: 'PERCENTAGE', label: '%' }]}
                onChange={(v) => update(i, { operator: v })}
              />
            </div>

            <label className="simple-offer__field">
              <span className="simple-offer__label">{isCash ? 'Bonus amount' : 'Percentage of ticket sales'}</span>
              <input
                data-testid="bonus-amount"
                className="simple-offer__input"
                type="number"
                value={b.amount}
                onChange={(e) => update(i, { amount: e.target.value })}
              />
            </label>

            <button
              type="button"
              data-testid="delete-bonus"
              className="simple-offer__icon-btn"
              aria-label="Delete bonus"
              onClick={() => remove(i)}
            >
              <i className="far fa-trash" aria-hidden="true" />
            </button>
          </div>
        );
      })}

      <button type="button" data-testid="add-bonus" className="simple-offer__add-link" onClick={add}>
        + Add Bonus
      </button>
    </section>
  );
};

BonusRows.propTypes = {
  bonuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BonusRows;
